import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["color", "size"];
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export var IconMail = function IconMail(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color
  }, otherProps), {}, {
    viewBox: "0 0 40 40",
    children: /*#__PURE__*/_jsx("path", {
      d: "M1.666 11.666a5 5 0 015-5h26.668a5 5 0 015 5v16.668a5 5 0 01-5 5H6.666a5 5 0 01-5-5V11.666zm5-2.5c-.337 0-.671.068-.982.2l12.066 9.05c1.332 1 3.166 1 4.5 0l12.066-9.05c-.31-.132-.645-.2-.982-.2H6.666zm-2.48 2.2c-.013.1-.02.2-.02.3v16.668a2.5 2.5 0 002.5 2.5h26.668a2.5 2.5 0 002.5-2.5V11.666c0-.1-.006-.2-.02-.3l-12.064 9.05a6.25 6.25 0 01-7.5 0L4.184 11.368l.002-.002z"
    })
  }));
};
export default IconMail;